import React, { forwardRef } from 'react';
import styles from './StatusBadge.module.css';

export type StatusType = 'active' | 'pending' | 'matured' | 'sold' | 'rejected';
export type StatusVariant = 'badge' | 'pill';

const STATUS_LABELS: Record<StatusType, string> = {
  active: 'Ongoing',
  pending: 'Pending',
  matured: 'Matured',
  sold: 'Sold',
  rejected: 'Rejected',
};

export interface IStatusBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  status: StatusType;
  variant?: StatusVariant;
  label?: string;
}

const StatusBadge = forwardRef<HTMLSpanElement, IStatusBadgeProps>(
  ({ status, variant = 'badge', label, className, ...rest }, ref) => {
    const displayLabel = label || STATUS_LABELS[status] || status;
    const baseClass = variant === 'pill' ? styles.pill : styles.badge;

    return (
      <span
        ref={ref}
        className={`${baseClass} ${styles[status] || ''} ${className || ''}`}
        {...rest}
      >
        {displayLabel}
      </span>
    );
  },
);

StatusBadge.displayName = 'StatusBadge';

export default StatusBadge;
